<template>
  <v-container fluid grid-list-sm>
    <v-layout justify-end row>
      <v-flex xs12 sm3 md3>
        <v-select
          dense
          v-model="selectedFirm"
          :items="firmsByBrand"
          label="Select Firm"
          clearable
        >
        </v-select>
      </v-flex>

      <v-spacer></v-spacer>

      <v-flex xs12 sm2 md2>
        <v-menu
          :close-on-content-click="false"
          v-model="datepickerMenu"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="date"
            label="Date"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm2 md2>
        <v-select
          dense
          v-model="voucherTypeFilter"
          multiple
          :items="[
          'Receipt',
          'Payment',
          'Credit Note',
          'Debit Note',
          'Asset',
          'Expense',
          'Liability',
          'Income',
          'Staff',
          'Transfer',
          'Advance',
          'LoanGiven',
          'LoanTaken',
          'Security',
          'Opening Balance',
          'Sale',
          'Purchase'
          ]"
         label="Filter Voucher Type"
         clearable
       >
      </v-select>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs12 sm1 md1>
        <v-switch
          v-model="isProductView"
          :label="`${!isProductView ? 'Product' : 'Invoice'}`"
        ></v-switch>
      </v-flex>

      <v-flex xs12 sm1 md1 style="margin-top: 10px">
        <v-btn
        v-if="!isProductView"
          @click="printInv()"
          class="primary white--text"
        >
          Print
        </v-btn>
        <v-btn
        v-if="!isProductView"
          @click="printStripInv()"
          class="primary white--text"
        >
          Strip Print
        </v-btn>

        <v-btn
         v-if="isProductView && isProductGroupView"
          @click="productGroupReportPrint(false)"
          class="primary white--text"
        >
          Print (Simple)
        </v-btn>

        <v-btn
         v-if="isProductView && isProductGroupView"
          @click="productGroupReportPrint(true)"
          class="primary white--text"
        >
          Print (Detailed)
        </v-btn>

        <v-btn
         v-if="isProductView && !isProductGroupView"
          @click="productReportPrint()"
          class="primary white--text"
        >
          Print
        </v-btn>
      </v-flex>

      <v-flex xs12 sm1 md1 v-if="isProductView">
        <v-switch
          v-model="isProductGroupView"
          :label="`${!isProductGroupView ? 'Product Group' : 'Products'}`"
        ></v-switch>
      </v-flex>
    </v-layout>

    <template v-if="!isProductView">
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <invoice-list
            :firmAssignment="true"
            heading="DAYBOOK"
            :selectedFirm="selectedFirm"
            :selectedDate="date"
            :print="print"
            :stripPrint="stripPrint"
            :invoices="invoices"
            :firms="firms"
            :buyers="buyers"
            :sellers="sellers"
            :voucherTypeFilter="voucherTypeFilter"
          />
        </v-flex>
      </v-layout>
    </template>
    <template v-else>
      <v-layout row wrap>
        <v-flex xs12 sm12 v-if="!isProductGroupView">
          <v-card class="primary white--text text-xs-center body-2">
            <v-card-text>
              <h3>Product Transactions</h3>
            </v-card-text>
          </v-card>
          <v-data-table
            :items="productsTransaction"
            class="elevation prod-reports strip-table"
            :headers="headers"
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <td>
                <b class="font-weight-bold">{{ props.item["invoiceId"] }}</b>
              </td>
              <td>
                <b class="font-weight-bold"
                  >{{ firmNameById(props.item.firm) || "Not Assigned" }}
                </b>
              </td>
              <td>
                <b class="font-weight-bold"
                  >{{ buyerById(props.item.buyerId) || "Not Assigned" }}
                </b>
              </td>
              <td>
                <b class="font-weight-bold">{{ props.item.productName }} </b>
              </td>
              <td>
                <b class="font-weight-bold"
                  >{{ props.item.availableQuantity }}
                  {{
                    getMajorQuantity(
                      props.item.availableQuantity,
                      props.item.productId
                    )
                  }}</b
                >
              </td>
              <template v-if="!props.item.isBuyer">
                <td>
                  <b class="font-weight-bold"
                    >{{ props.item.quantity }}
                    {{
                      getMajorQuantity(
                        props.item.quantity,
                        props.item.productId
                      )
                    }}</b
                  >
                </td>
                <td></td>
              </template>
              <template v-else>
                <td></td>
                <td>
                  <b class="font-weight-bold"
                    >{{ props.item.quantity }}
                    {{
                      getMajorQuantity(
                        props.item.quantity,
                        props.item.productId
                      )
                    }}</b
                  >
                </td>
              </template>
              <td>
                <b class="font-weight-bold" v-if="props.item.isBuyer">{{ props.item.basicPrice }} </b>
              </td>
              <td>
                <b class="font-weight-bold"
                  >{{
                    props.item.isBuyer
                      ? Number.parseFloat(
                          Number.parseFloat(props.item.availableQuantity) -
                            Number.parseFloat(props.item.quantity)
                        )
                      : Number.parseFloat(
                          Number.parseFloat(props.item.availableQuantity) +
                            Number.parseFloat(props.item.quantity)
                        )
                  }}
                </b>
              </td>
            </template>
            <template slot="no-data"> No rows to Show </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 sm12 v-else>
          <v-card class="primary white--text text-xs-center body-2">
            <v-card-text>
              <h3>Product Group Transactions</h3>
            </v-card-text>
          </v-card>
          <v-data-table
            :items="groupsTransaction"
            class="elevation prod-grp-reports strip-table"
            :headers="groupHeaders"
            :expand="true"
            item-key="name"
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded; " :class="(props.item.name != 'Total' ? (!props.expanded ? 'not-expand product-group-row' : 'product-group-row') : '')">
              <td>
                <b class="font-weight-bold">{{ props.item.name }} </b>
              </td>
              <td>
                <b class="font-weight-bold"
                  >{{ props.item.availableQuantity }}
                  {{
                    getMajorQuantityGroup(
                      props.item.sameMajorUnit,
                      props.item.availableQuantity,
                      props.item.majorUnitQuantity,
                      props.item.majorUnit
                    )
                  }}</b
                >
              </td>
              <td>
                <b class="font-weight-bold primary--text"
                  >{{ props.item.purchaseQuantity }}
                  {{
                    getMajorQuantityGroup(
                      props.item.sameMajorUnit,
                      props.item.purchaseQuantity,
                      props.item.majorUnitQuantity,
                      props.item.majorUnit
                    )
                  }}</b
                >
              </td>
              <td>
                <b class="font-weight-bold success--text">{{ Number.parseFloat(props.item.purchaseAmount).toFixed(2) }} </b>
              </td>
              <td>
                <b class="font-weight-bold"
                  >{{ props.item.sellingQuantity }}
                  {{
                    getMajorQuantityGroup(
                      props.item.sameMajorUnit,
                      props.item.sellingQuantity,
                      props.item.majorUnitQuantity,
                      props.item.majorUnit
                    )
                  }}</b
                >
              </td>
              <td>
                <b class="font-weight-bold">{{ Number.parseFloat(props.item.saleAmount).toFixed(2) }} </b>
              </td>
              <td>
                <b class="font-weight-bold"
                  >{{ props.item.closingQuantity }}
                  {{
                    getMajorQuantityGroup(
                      props.item.sameMajorUnit,
                      props.item.closingQuantity,
                      props.item.majorUnitQuantity,
                      props.item.majorUnit
                    )
                  }}</b
                >
              </td>
              </tr>
            </template>
            <template v-slot:expand="props">
              <v-card flat  v-if="props.item.name != 'Total'">
                <v-card-text>
                  <v-switch
                    v-model="combineProduct"
                   :label="`Combined Product : ${combineProduct ? 'YES' : 'NO'}`"
                  ></v-switch>
                </v-card-text>
                <v-data-table
                  :items="props.item.products"
                  class="elevation prod-reports strip-table"
                  v-if="!combineProduct"
                  :headers="headers"
                  hide-actions
                >
                  <template slot="items" slot-scope="props">
                    <td>
                      <b class="font-weight-bold">{{ props.item["invoiceId"] }}</b>
                    </td>
                    <td>
                      <b class="font-weight-bold"
                        >{{ firmNameById(props.item.firm) || "Not Assigned" }}
                      </b>
                    </td>
                    <td>
                      <b class="font-weight-bold"
                        >{{ buyerById(props.item.buyerId) || "Not Assigned" }}
                      </b>
                    </td>
                    <td>
                      <b class="font-weight-bold">{{ props.item.productName }} </b>
                    </td>
                    <td>
                      <b class="font-weight-bold"
                        >{{ props.item.availableQuantity }}
                        {{
                          getMajorQuantity(
                            props.item.availableQuantity,
                            props.item.productId
                          )
                        }}</b
                      >
                    </td>
                    <template v-if="!props.item.isBuyer">
                      <td>
                        <b class="font-weight-bold"
                          >{{ props.item.quantity }}
                          {{
                            getMajorQuantity(
                              props.item.quantity,
                              props.item.productId
                            )
                          }}</b
                        >
                      </td>
                      <td></td>
                    </template>
                    <template v-else>
                      <td></td>
                      <td>
                        <b class="font-weight-bold"
                          >{{ props.item.quantity }}
                          {{
                            getMajorQuantity(
                              props.item.quantity,
                              props.item.productId
                            )
                          }}</b
                        >
                      </td>
                    </template>
                    <td>
                      <b class="font-weight-bold">{{ props.item.basicPrice }} </b>
                    </td>
                    <td>
                      <b class="font-weight-bold"
                        >{{
                          props.item.isBuyer
                            ? Number.parseFloat(
                                Number.parseFloat(props.item.availableQuantity) -
                                  Number.parseFloat(props.item.quantity)
                              )
                            : Number.parseFloat(
                                Number.parseFloat(props.item.availableQuantity) +
                                  Number.parseFloat(props.item.quantity)
                              )
                        }}
                      </b>
                    </td>
                  </template>
                  <template slot="no-data"> No rows to Show </template>
                </v-data-table>
                <v-data-table
                  v-else
                  :items="props.item.unqProducts"
                  class="elevation prod-reports strip-table"
                  hide-actions
                  :headers="unqProdHeader"
                >
                  <template slot="items" slot-scope="props">
                    <td>
                      <b class="font-weight-bold">{{ props.item.productName }} </b>
                    </td>
                    <td>
                      <b class="font-weight-bold"
                        >
                        {{ props.item.saleQuantity }}
                        {{
                          getMajorQuantity(
                            props.item.saleQuantity,
                            props.item.productId
                          )
                        }}</b
                      >
                    </td>
                    <td>
                      <b class="font-weight-bold"
                        >{{ props.item.saleAmount }}
                      </b>
                    </td>
                    <!-- <td>
                      {{ Number.parseFloat(Number.parseFloat(props.item.saleQuantity) * Number.parseFloat(props.item.saleAmount)) }}
                    </td> -->
                  </template>
                  <template slot="no-data"> No rows to Show </template>
                  </v-data-table>
              </v-card>
            </template>            
            <template slot="no-data"> No rows to Show </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </template>

    <v-snackbar v-model="snackbar" top color="error" :timeout="3000">
      {{ snackbarText }}
    </v-snackbar>
    <v-snackbar v-model="snackbarSuccess" top color="success" :timeout="3000">
      {{ snackbarSuccessText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import InvoiceList from "./invoiceList.vue";
// import { setTimeout } from "timers";
import { dailyProductReport,dailyProductGroupReport } from "../../utils/pdf-reports/dailyProductReport.js";

export default {
  components: {
    InvoiceList,
  },
  data: () => ({
    headers: [
      { text: "Invoice ID", value: "expense", sortable: true },
      { text: "Firm", value: "firm", sortable: true },
      { text: "Customer Name", value: "name", sortable: true },
      { text: "Product Name", value: "category", sortable: true },
      { text: "Opening Quantity", value: "availableQuantity", sortable: false },
      { text: "Purchase Quantity", value: "quantity", sortable: false },
      { text: "Sale Quantity", value: "quantity", sortable: false },
      { text: "Amount", value: "quantity", sortable: false },
      { text: "Closing Quantity", value: "closingQuantity", sortable: false },
    ],
    groupHeaders: [
      { text: "Group Name", value: "category", sortable: true },
      { text: "Opening Quantity", value: "availableQuantity", sortable: false },
      { text: "Purchase Quantity", value: "quantity", sortable: false },
      { text: "Purchase Amount", value: "quantity", sortable: false },
      { text: "Sale Quantity", value: "quantity", sortable: false },
      { text: "Sale Amount", value: "quantity", sortable: false },
      { text: "Closing Quantity", value: "closingQuantity", sortable: false },
    ],
    isProductGroupView: false,
    color: null,
    expand : true,
    isProductView: false,
    unqProdHeader :[
      { text: "Product Name", value: "category", sortable: true },
      { text: "Sale Quantity", value: "quantity", sortable: false },
      { text: "Sale Amount", value: "quantity", sortable: false },
      // { text: "Sale Amount", value: "quantity", sortable: false },
    ],
    timeout: 3000,
    datepickerMenu: false,
    snackbarSuccessText: null,
    snackbarText: null,
    snackbar: false,
    snackbarSuccess: false,
    date: null,
    print: false,
    stripPrint: false,
    selectedFirm: null,
    voucherTypeFilter : [],
    filterFlag : null,
    combineProduct : false,
  }),
  created() {
    this.$bindAsArray(
      "firms",
      this.$root.$firebaseRefs.firm
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "invoices",
      this.$root.$firebaseRefs.invoice
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsObject(
      "sellers",
      this.$root.$firebaseRefs.seller
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsObject(
      "buyers",
      this.$root.$firebaseRefs.buyer
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "products",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "productGroups",
      this.$root.$firebaseRefs.productGroup
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    let today = new Date();
    this.date = `${today.getFullYear()}-${
      today.getMonth() + 1
    }-${today.getDate()}`;
    this.salaryInvoiceDate = `${today.getFullYear()}-${
      today.getMonth() + 1
    }-${today.getDate()}`;
    this.transferInvoiceDate = `${today.getFullYear()}-${
      today.getMonth() + 1
    }-${today.getDate()}`;
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","brandFinYear"]),

    firmsByBrand() {
      return this.firms
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (item.defaultFirm) {
            this.selectedFirm = item[".key"];
          }
          return {
            firm: item,
            text: item["name"],
            value: item[".key"],
          };
        });
    },
    productsTransaction() {
      let productList = [];
      let inv = this.invoices.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          (this.selectedFirm ? item["firm"] === this.selectedFirm : true) &&
          item.deleted != true &&
          (this.date
            ? new Date(this.date).toLocaleDateString() ===
              new Date(item["date"]).toLocaleDateString()
            : false)
      );
      inv.map((invoice, index) => {
        if (invoice.items) {
          invoice.items.map((item, index) => {
            item["firm"] = invoice["firm"];
            item["buyerId"] = invoice["buyerId"];
            item["isBuyer"] = invoice["isBuyer"];
            item["date"] = invoice["date"];
            item["invoiceId"] = invoice["invoiceId"];
            productList.push(item);
          });
        }
      });
      return productList;
    },
    groupsTransaction() {
      let groupList = [];
      let inv = this.invoices.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          (this.selectedFirm ? item["firm"] === this.selectedFirm : true) &&
          item.deleted != true &&
          (this.date
            ? new Date(this.date).toLocaleDateString() ===
              new Date(item["date"]).toLocaleDateString()
            : false)
      );
      let total = {
        name: "Total",
        id: null,
        availableQuantity:  0,
        sellingQuantity:  0,
        purchaseQuantity:  0,
        closingQuantity: 0,
        saleAmount:  0,
        purchaseAmount: 0,
      };
      inv.map((invoice) => {
        if (invoice.items) {
          invoice.items.map((item) => {
            let product = this.products.find(
              (item1) => item1[".key"] == item["productId"]
            );
            let group = null;
            item["firm"] = invoice["firm"];
            item["buyerId"] = invoice["buyerId"];
            item["isBuyer"] = invoice["isBuyer"];
            item["date"] = invoice["date"];
            item["invoiceId"] = invoice["invoiceId"];
            item["saleQuantity"] =  invoice["isBuyer"]? item.quantity : 0;
            item["purchaseQuantity"] =  !invoice["isBuyer"]? item.quantity : 0;
            item["saleAmount"] =  invoice.isBuyer
                    ? Number.parseFloat(item.basicPrice)
                    : 0;
            item["purchaseAmount"] = !invoice.isBuyer
                    ? Number.parseFloat(item.basicPrice)
                    : 0;
            if (product && product["productGroup"]) {
              group = this.productGroups.find(
                (item1) => item1[".key"] == product["productGroup"]
              );
              if (group) {
                group = {
                  name: group.name,
                  id: group[".key"],
                  availableQuantity: Number.parseFloat(item.availableQuantity )|| 0,
                  sellingQuantity: invoice.isBuyer ? item.quantity : 0,
                  purchaseQuantity: !invoice.isBuyer ? item.quantity : 0,
                  closingQuantity: invoice.isBuyer
                    ? Number.parseFloat(
                        Number.parseFloat(item.availableQuantity) -
                          Number.parseFloat(item.quantity)
                      )
                    : Number.parseFloat(
                        Number.parseFloat(item.availableQuantity) +
                          Number.parseFloat(item.quantity)
                      ),
                  majorUnit: product.majorUnit,
                  majorUnitQuantity: product.majorUnitQuantity,
                  sameMajorUnit: true,
                  saleAmount: invoice.isBuyer
                    ? Number.parseFloat(item.basicPrice)
                    : 0,
                  purchaseAmount: !invoice.isBuyer
                    ? Number.parseFloat(item.basicPrice)
                    : 0,
                };
              }
            }
            if (!group) {
              group = {
                name: "Non Group",
                id: null,
                availableQuantity: Number.parseFloat(item.availableQuantity) || 0,
                sellingQuantity: invoice.isBuyer ? item.quantity : 0,
                purchaseQuantity: !invoice.isBuyer ? item.quantity : 0,
                closingQuantity: invoice.isBuyer
                  ? Number.parseFloat(
                      Number.parseFloat(item.availableQuantity) -
                        Number.parseFloat(item.quantity)
                    )
                  : Number.parseFloat(
                      Number.parseFloat(item.availableQuantity) +
                        Number.parseFloat(item.quantity)
                    ),
                saleAmount: invoice.isBuyer
                  ? Number.parseFloat(item.basicPrice)
                  : 0,
                purchaseAmount: !invoice.isBuyer
                  ? Number.parseFloat(item.basicPrice)
                  : 0,
              };
            }
            let index = groupList.findIndex((x) => x.id === group.id);
            if (index > -1) {
              if (
                groupList[index].sameMajorUnit &&
                groupList[index].majorUnit != group.majorUnit
              ) {
                groupList[index].sameMajorUnit = false;
              }
              groupList[index]["availableQuantity"] +=
                group["availableQuantity"];
              groupList[index]["sellingQuantity"] +=  Number.parseFloat(group["sellingQuantity"]);
              groupList[index]["purchaseQuantity"] +=  Number.parseFloat(group["purchaseQuantity"]);
              groupList[index]["closingQuantity"] +=  Number.parseFloat(group["closingQuantity"]);
              groupList[index]["saleAmount"] += Number.parseFloat( invoice.isBuyer
                ? Number.parseFloat(group["saleAmount"])
                : 0);
              groupList[index]["purchaseAmount"] +=  Number.parseFloat(!invoice.isBuyer
                ? Number.parseFloat(group["purchaseAmount"])
                : 0);
                 groupList[index]["products"].push(item);
                 let ind = groupList[index]["unqProducts"].findIndex(i => i.productId == item.productId);
                 if(ind > -1) {
                    groupList[index]["unqProducts"][ind]["saleQuantity"] += item["saleQuantity"]
                    groupList[index]["unqProducts"][ind]["saleAmount"] = Number.parseFloat(Number.parseFloat(invoice.isBuyer ? (groupList[index]["unqProducts"][ind]["saleAmount"] || 0) : 0) + Number.parseFloat(invoice.isBuyer
                    ? Number.parseFloat(item.basicPrice)
                    : 0));
                    groupList[index]["unqProducts"][ind]["purchaseQuantity"] += item["purchaseQuantity"]
                 } else {
                    groupList[index]["unqProducts"].push(item);
                 }
                 if(item.productName == 'SOYA 1/2 LTR') {
                   debugger
                 }
                total['availableQuantity'] += Number.parseFloat(group['availableQuantity']);
                total['sellingQuantity'] += Number.parseFloat(group['sellingQuantity']);
                total['purchaseQuantity'] += Number.parseFloat(group['purchaseQuantity']);
                total['closingQuantity'] += Number.parseFloat(group['closingQuantity']);
                total['saleAmount'] += Number.parseFloat(invoice.isBuyer
                ? Number.parseFloat(group["saleAmount"])
                : 0);
                total['purchaseAmount'] += Number.parseFloat(!invoice.isBuyer
                ? Number.parseFloat(group["purchaseAmount"])
                : 0);
            } else {
              group['products'] = [item]
              group['unqProducts'] = [item]
              groupList.push(group);
              total['availableQuantity'] += Number.parseFloat(group['availableQuantity']);
              total['sellingQuantity'] += Number.parseFloat(group['sellingQuantity']);
              total['purchaseQuantity'] += Number.parseFloat(group['purchaseQuantity']);
              total['closingQuantity'] += Number.parseFloat(group['closingQuantity']);
              total['saleAmount'] += Number.parseFloat(group['saleAmount']);
              total['purchaseAmount'] += Number.parseFloat(group['purchaseAmount']);
            }
          });
        }
      });
      groupList.push(total);
      return groupList;
    },
  },
  methods: {
    productReportPrint() {
      const htmlToArray = (tableElement) => {
        const thead = tableElement.querySelector("thead");
        const tbody = tableElement.querySelector("tbody");
        // Assumes there's only one header row
        const columns = thead.querySelectorAll("tr th");
        const columnNames = [];
        columns.forEach((c) => columnNames.push(c.innerText));
        const result = [];
        const bodyRows = tbody.querySelectorAll("tr");
        bodyRows.forEach((r) => {
          const tds = r.querySelectorAll("td");
          const arr = [];
          tds.forEach((td, idx) => {
            arr.push(td.innerText);
          });
          result.push(arr);
        });
        return result;
      };
      const table = document.querySelector(".prod-reports");
      let invoices = htmlToArray(table);
      let doc = dailyProductReport({
        invoiceData: invoices,
        firm: this.selectedFirm ? this.selectedFirm.name : "",
        date: this.date ? new Date(this.date).toLocaleDateString("en-GB") : "",
      });
      pdfMake.createPdf(doc).download("product-report");
    },
    productGroupReportPrint(isDetailed) {
      if(isDetailed) {
       $(".not-expand.product-group-row").click()
      }
      const htmlToArray = (tableElement) => {
        const thead = tableElement.querySelector("thead");
        const tbody = tableElement.querySelector("tbody");
        // Assumes there's only one header row
        const columns = thead.querySelectorAll("tr th");
        const columnNames = [];
        columns.forEach((c) => columnNames.push(c.innerText));
        const result = [];
        const bodyRows = tbody.querySelectorAll("tr");
        bodyRows.forEach((r) => {
          const tds = r.querySelectorAll("td");
          const arr = [];
          tds.forEach((td, idx) => {
            arr.push(td.innerText);
          });
          result.push(arr);
        });
        return result;
      };
      setTimeout(() => {
        const table = document.querySelector(".prod-grp-reports");
        let invoices = htmlToArray(table);
        let doc = dailyProductGroupReport({
          invoiceData: invoices,
          firm: this.selectedFirm ? this.selectedFirm.name : "",
          date: this.date ? new Date(this.date).toLocaleDateString("en-GB") : "",
          isDetailed : isDetailed
        });
        pdfMake.createPdf(doc).download("product-report");
        $(".product-group-row").click()
      }, 1500);
    },
    getMajorQuantity(quantity, productId) {
      let product = this.products.find((item) => item[".key"] == productId);
      if (product && product.majorUnit) {
        let text =
          "(" +
          Number.parseFloat(quantity / (product.majorUnitQuantity || 1)).toFixed(2) +
          " " +
          product.majorUnit +
          ")";
        return text;
      }
      return "";
    },
    getMajorQuantityGroup(
      sameMajorUnit,
      quantity,
      majorUnitQuantity,
      majorUnit
    ) {
      if (sameMajorUnit && majorUnitQuantity && majorUnit) {
        let text = "(" + quantity / majorUnitQuantity + " " + majorUnit + ")";
        return text;
      }
      return "";
    },
    printInv() {
      this.print = true;
      setTimeout(() => {
        this.print = false;
      }, 100);
    },
    printStripInv() {
      this.stripPrint = true;
      setTimeout(() => {
        this.stripPrint = false;
      }, 100);
    },
    notify(message, isSuccess) {
      if (isSuccess) {
        this.snackbarSuccess = true;
        this.snackbarSuccessText = message;
      } else {
        this.snackbar = true;
        this.snackbarText = message;
      }
    },
    closeDialog() {
      this.dialog12 = false;
    },
    buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id].name;
      } else if (this.sellers[id]) {
        return this.sellers[id].name;
      } else {
        return "--DELETED--";
      }
    },
    firmNameById(id) {
      return this.firms.filter((item) => item[".key"] == id)[0].name;
    },
  },
  watch: {},
};
</script>
<style>
.strip-table tbody tr:nth-child(odd){
  background-color: #d5d5d5;
}
</style>


// WEBPACK FOOTER //
// src/components/DailyTransactions/index.vue